export const footerData = [
    {
        id: 1,
        footerTitle: 'Getting started',
        lists: [
            {
                id: 1,
                title: 'Home Page',
                path: '/',
            },
            {
                id: 2,
                type: 'login_logout',
            },
            {
                id: 3,
                title: 'Create Account',
                path: '/registration',
                isLoggedIn: false,
            },
            {
                id: 4,
                title: 'About Us',
                path: '/about-us',
                // isLoggedIn: true,
            },
            // {
            //     id: 4,
            //     title: 'Sell with Us',
            //     path: '/seller/registration',
            //     isLoggedIn: true,
            // },
        ],
    },
    {
        id: 2,
        footerTitle: 'Stay Connected',
        lists: [
            {
                id: 1,
                title: 'Contact Us',
                path: '/contact-us',
            },
            {
                id: 2,
                title: 'Facebook',
                path: 'https://www.facebook.com/zipperbuy/',
                external: true,
            },
            {
                id: 3,
                title: 'Instagram',
                path: 'https://www.instagram.com/zipperbuy/',
                external: true,
            },
            // {
            //     id: 4,
            //     title: 'About us',
            //     path: '/about-us',
            // },
            // {
            //     id: 5,
            //     title: 'Help',
            //     path: '/contact-us',
            // },
        ],
    },
    {
        id: 3,
        footerTitle: 'Resources',
        lists: [
            {
                id: 1,
                title: 'Terms and Conditions',
                path: '/terms-and-conditions',
            },
            {
                id: 2,
                title: 'Privacy Policy',
                path: '/privacy-policy',
            },
            {
                id: 3,
                title: `Glossary`,
                path: '/glossary',
            },
            {
                id: 4,
                title: 'FAQ',
                path: '/contact-us',
            },
            // {
            //     id: 4,
            //     title: 'View Map of Location',
            //     path: '/locationmap',
            // },
        ],
    },
    // {
    //     id: 4,
    //     footerTitle: 'Stay connected',
    //     lists: [
    //         {
    //             id: 1,
    //             title: 'Facebook',
    //             path: 'https://www.facebook.com/zipperbuy/',
    //             img: '/assets/svg/footer-fb.svg',
    //         },
    //         {
    //             id: 2,
    //             title: 'Instagram',
    //             path: 'https://www.instagram.com/zipperbuy/',
    //             img: '/assets/svg/footer-insta.svg',
    //         },
    //     ],
    // },
]
